import { CLIENT_COMPUTED_WIDGET_TYPES } from '../constants';

/**
 * Check if the given widget type if in the list of client computed widgets.
 */
export function isClientComputed(widgetType: string) {
    return CLIENT_COMPUTED_WIDGET_TYPES.includes(widgetType as any);
}
